import React, { Component } from 'react';
import { connect } from 'react-redux';
import Server from './Server.js'
import Footer from './Footer.js'
import LoginBox from "./LoginBox.js";
import { Dialog } from 'primereact/dialog';
import {  Link, Navigate } from 'react-router-dom'
import Swiper from 'react-id-swiper';
import 'swiper/swiper.min.css'
import { ProgressSpinner } from 'primereact/progressspinner';

const params5 = {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  loop: 1,
  centeredSlides: true,
  slidesPerView: 'auto',
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: true
  },
  pagination: {
    el: '.swiper-pagination'
  }
}
class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef()   // Create a ref object
    localStorage.removeItem("food");

    this.Server = new Server();
    this.state = {
      activePage: 1,    
      CurrentTab: 1,
      credit: 0,
      BankBox:false,
      appData: this.props.appData,
      absoluteUrl: this.Server.getAbsoluteUrl(),

    }
    this.getAppData = this.getAppData.bind(this);



  }
  componentDidMount() {
    if(!this.props.appData.lName){
      this.getAppData();
    }
    this.getPics();

  }
  
  getAppData(){
    let that= this;
    this.setState({
      ShowLoading: true
    })
    let SCallBack = function (response) {
      const appData = response.data.result[0]||{};
      that.setState({
        appData:appData,
        ads:response.data.ads ? response.data.ads[0] : {}
      })
      that.props.dispatch({
        type: "noLogin",
        appData:appData
      })
      if(appData.multiSystem && !that.state.systemId){
        that.setState({
          showSystemBox: true
        })
      }
    };
    let ECallBack = function (error) {
      
    }
    const condition = this.state.System ? {condition:{code:this.state.System.code}} : {condition:{code:1000}};
    this.Server.send("MainApi/getAppData", condition, SCallBack, ECallBack)
  }
  getPics() {
    let that = this;
    this.Server.send("MainApi/getPics", {}, function (response) {
      response.data.result.map(function (item, index) {
        if (item.name == "extra-file1"){
          that.setState({
            logo1: item.fileUploaded ? that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1] : null,
            link1: item.link
          })
        }
         
        if (item.name == "extra-file2")
          that.setState({
            logo2: item.fileUploaded ?  that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1] : null,
            link2: item.link
          })
        if (item.name == "extra-file3")
          that.setState({
            logo3: item.fileUploaded ?  that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1] : null,
            link3: item.link
          })
        if (item.name == "file4")
          that.setState({
            logo4: item.fileUploaded ? that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1] : null,
            link4: item.link,
            text4: item.text
          })
          
        if (item.name == "file5")
          that.setState({
            logo5: item.fileUploaded ? that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1]:null,
            link5: item.link,
            text5: item.text
          })
        if (item.name == "file8")
          that.setState({
            logo8: item.fileUploaded ? that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1]:null,
            link8: item.link,
            text8: item.text
          })
        if (item.name == "file9")
          that.setState({
            logo9: item.fileUploaded ? that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1]:null,
            link9: item.link,
            text9: item.text
          })  
        if (item.name == "file11"){
          that.setState({
            SpecialImage: that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1]
          })
        }
        if (item.name == "file13"){

          that.setState({
            loading_pic: that.state.absoluteUrl +  item?.fileUploaded?.split("public")[1]
          })
        }
            
      })
      setTimeout(()=>{
        that.setState({
          ShowLoading:0
        })
      },1)
      
    }, function () {

    })

  }

  render() {
    if (this.state.page) {
      return <Navigate to={this.state.page} />;
    }
    return (

      <div style={{ height: '100%' }} className="sarv-bg1 sarv-home-top-box">
        {!this.state.ShowLoading ?
        <div className="sarv-bg1 sarv-home-top-box">
        <div className="sarv-home-top-box">
        <div style={{textAlign:'center',display:'flex',justifyContent:'center'}}>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center',paddingLeft:10,paddingRight:10,marginTop:30 }}>
            <div style={{ width: '80%' }}>
              <img src={`./icons/${this.state.appData?.lName}/top-logo-home.png`} style={{ width: '100%' }} />

            </div>
            <div style={{ width: '20%' }}>
              <img src={`./icons/${this.state.appData?.lName}/logo.png`} style={{ width: 40 }} />

            </div>
          </div>
        </div>
         
        <div style={{textAlign:'center',display:'flex',justifyContent:'center',marginTop:20,position: 'absolute',zIndex:2}} >
          <div style={{width:'90%'}}>
              <Swiper {...params5} >
                    <div>
                      {this.state.link1 && this.state.link1.indexOf("http") > -1 ?
                        <Link to={this.state.link1} className=""  style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo1} style={{ borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text1} />
                        </Link>
                        :
                        <Link to={`${process.env.PUBLIC_URL}/` + this.state.link1} className=""  href="#" style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo1} style={{ borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text1} />
                        </Link>
                      }
                    </div>
                    <div>
                      {this.state.link2 && this.state.link2.indexOf("http") > -1 ?
                        <Link to={this.state.link2} className=""  style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo2} style={{borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text2} />

                        </Link>
                        :
                        <Link to={`${process.env.PUBLIC_URL}/` + this.state.link2} className=""  href="#" style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo2} style={{ borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text2} />

                        </Link>
                      }
                    </div>
                    <div>
                      {this.state.link3 && this.state.link3.indexOf("http") > -1 ?
                        <Link to={this.state.link3} className=""  style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo3} style={{ borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text3} />
                        </Link>
                        :
                        <Link to={`${process.env.PUBLIC_URL}/` + this.state.link3} className=""  href="#" style={{ textDecoration: 'none' }}>
                          
                          <img src={this.state.logo3} style={{ borderRadius: 12, whiteSpace: 'pre-wrap',height:196,width:'100%' }} title={this.state.text3} />
                        </Link>
                      }
                    </div>
                  </Swiper>
                 
                  </div>
          </div>
          </div>
         
          <div style={{display:this.state.BankBox ? 'none' : 'block',textAlign:'center'}} >
              <p>خوش آمدید</p>
          </div>
          

        
        <div style={{height:80}}>

          </div>
        <div style={{position:'fixed',bottom:0,width:'100%'}}>
          {this.state.appData && this.state.appData.lName &&
             <Footer noBack="1" appData={this.state.appData} bgColor="#fff" />
          }

        </div>
        
        </div>
        :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',height:'100%' }}>
          <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
      }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    LoginAnia:state.LoginAnia,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(LandingPage)

